import { notification } from 'antd';
import { all, call, put, take } from 'redux-saga/effects';
import { FORGOT_PASSWORD, VERIFY_CODE, CHANGE_PASSWORD } from '../type';
import { setToken } from 'services/axios';
import { history } from 'store';
import {
  forgotPasswordSuccessAction,
  forgotPasswordErrorAction,
  verifyCodeSuccessAction,
  verifyCodeErrorAction,
  changePasswordSuccessAction,
  changePasswordErrorAction,
  loginAction,
} from '../action';

import { authService } from 'services';

function* forgotPassword() {
  while (1) {
    const action = yield take(FORGOT_PASSWORD);
    const { username, email } = action.payload;
    try {
      const forgotPasswordResponse = yield call(
        authService.forgotPassword,
        action.payload,
      );

      yield put(forgotPasswordSuccessAction(forgotPasswordResponse));

      history.push(
        `/reset-password/verify?username=${username}&email=${email}`,
      );
      notification.success({
        message: 'Verification Code has been sent',
      });
    } catch (err) {
      notification.error({
        message: err.message,
      });
      yield put(forgotPasswordErrorAction(err));
    }
  }
}

function* verifyCode() {
  while (1) {
    const action = yield take(VERIFY_CODE);
    try {
      const verifyCodeResponse = yield call(
        authService.verifyCode,
        action.payload,
      );
      const { token, username, profileID } = verifyCodeResponse.data;

      yield put(verifyCodeSuccessAction(verifyCodeResponse));
      setToken(token);
      history.push(
        `/reset-password/finish?username=${username}&staffId=${profileID}`,
      );
    } catch (err) {
      notification.error({
        message: err.message,
      });
      yield put(verifyCodeErrorAction(err));
    }
  }
}

function* changePassword() {
  while (1) {
    const action = yield take(CHANGE_PASSWORD);
    const { username, newPassword } = action.payload;
    try {
      const verifyCodeResponse = yield call(
        authService.changePassword,
        action.payload,
      );

      yield put(changePasswordSuccessAction(verifyCodeResponse));
      yield put(
        loginAction({
          username,
          password: newPassword,
        }),
      );
    } catch (err) {
      notification.error({
        message: err.message,
      });
      yield put(changePasswordErrorAction(err));
    }
  }
}

export default function* rootSaga() {
  yield all([forgotPassword(), verifyCode(), changePassword()]);
}
